export default {
  "Cut Audio": "Вырезать Аудио",
  "HitPaw Online Audio Cutter": "HitPaw Онлайн Аудио Резак",
  "Trim or cut any audio files online.": "Обрезать или вырезать любые аудиофайлы в Интернете.",
  "Cut": "Резать",
  "Fade in": "Постепенно нарастать",
  "Fade out": "Постепенно затухать",
  "Cut from": "Вырезано из",
  "to": "к",
  "Extract selection": "Выбрать отрезок",
  "Delete selection": "Удалить отрезок",
  "Adjust New": "Настроить Новый",
  "Cut New": "Вырезать Новые",
  "Adjust Volume": "Отрегулируйте Громкость",
  "HitPaw Online Volume Changer": "HitPaw Онлайн-чейнджер громкости",
  "Turn up or Turn down the volume of audio.": "Увеличьте или уменьшите громкость звука.",
  "Volume": "Громкость",
  "Change Speed": "Изменение Скорости",
  "HitPaw Online Audio Speed Changer": "HitPaw Онлайн-чейнджер Скорости звука",
  "Speed up or slow down audios online easily.": "Легко ускоряйте или замедляйте аудиозаписи в Интернете.",
  "Speed": "Скорость",
  "Format": "Формат",
  "Size": "Размер",
  "Duration": "Продолжительность",
};
